import { useAuth } from "@/lib/auth";
import StretchMonthCalendar from "@/components/StretchMonthCalendar";
import SonographerTimeOff from "@/components/SonographerTimeOff";
import { CalendarClock } from "lucide-react";

export default function SonographerSchedule() {
  const { user } = useAuth();

  return (
    <div>
      <span className="pill">Schedule</span>
      <h1 className="mt-2 text-3xl font-bold flex items-center gap-3">
        <CalendarClock className="w-7 h-7" style={{ color: "var(--gold-hover)" }} />
        Clinic stretch schedule
      </h1>
      <p className="text-zinc-500 mt-1 text-sm">
        Every session your clinic schedules shows up here — subscribe once via the calendar-sync card and it stays in your work calendar automatically.
      </p>

      {user?.clinic_id ? (
        <>
          <div className="mt-6">
            <StretchMonthCalendar canEdit={false} showTemperatureTherapy />
          </div>
          <SonographerTimeOff />
        </>
      ) : (
        <div className="card-elev mt-6 text-sm text-zinc-500" data-testid="schedule-no-clinic">
          You&apos;re not linked to a clinic yet, so there&apos;s no shared schedule to show. Once you accept an invitation, this page will fill up with your clinic&apos;s upcoming stretch sessions.
        </div>
      )}
    </div>
  );
}
